import React from 'react';
import Head from 'next/head';

const Metadata = () => {
  const description =
    "Bellhop arranges simple, stress-free moving services. Book online in minutes and find out why we're one of the fastest-growing companies in our industry.";
  const descriptionTypes = ['description', 'og:description', 'twitter:description'];

  return (
    <Head>
      <title>Bellhop | The Modern Alternative to Traditional Moving Companies</title>
      <meta name="og:title" content="Bellhop | The Modern Alternative to Traditional Moving Companies" />
      {descriptionTypes.map(type => (
        <meta content={description} key={type} name={type} />
      ))}
      <meta name="robots" content="noindex, nofollow" />
    </Head>
  );
};

export default Metadata;
